var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import ChatbotBox from "./ChatbotBox";
import { Owner } from "../ChatbotService/ChatbotService";
import { RobotIcon } from "../Icons";
import useFeedback from "./useFeedback";
var ConsumerChatbotError = /** @class */ (function (_super) {
    __extends(ConsumerChatbotError, _super);
    function ConsumerChatbotError(originalError) {
        var _this = this;
        var originalMessage = originalError instanceof Error ? originalError.message : originalError;
        _this = _super.call(this, "ConsumerChatbotError: ".concat(originalMessage)) || this;
        _this.name = "ConsumerChatbotError";
        _this.originalError = originalError;
        return _this;
    }
    return ConsumerChatbotError;
}(Error));
var ChatWindow = function (props) {
    // contents of the text input
    var _a = useState(""), text = _a[0], setText = _a[1];
    // any error that occurs
    var _b = useState(null), error = _b[0], setError = _b[1];
    // whether the bot or agent is typing
    var _c = useState(false), isTyping = _c[0], setIsTyping = _c[1];
    var hasSentIntroMessage = useRef(false);
    useEffect(function () {
        var _a;
        if (hasSentIntroMessage.current) {
            return;
        }
        var name = ((_a = props.preChatData) === null || _a === void 0 ? void 0 : _a.firstName) || props.name;
        if (props.messages.length === 0 && name) {
            hasSentIntroMessage.current = true;
            var text_1 = props.uiLabels.introMessage.replace("{name}", name);
            props.addMessage({
                text: text_1,
                timestamp: Date.now(),
                owner: Owner.Bot,
                action: props.uiLabels.chatInitAction ? { type: "init" } : undefined,
            });
        }
    }, [
        props.messages,
        props.uiLabels.introMessage,
        props.preChatData,
        props.name,
        hasSentIntroMessage,
    ]);
    var _d = useFeedback({
        chatId: props.chatId,
        chatbotService: props.chatbotService,
    }), onGoodFeedback = _d.onGoodFeedback, onBadFeedback = _d.onBadFeedback;
    var onSend = useCallback(function (_text) { return __awaiter(void 0, void 0, void 0, function () {
        var sentMessage, replyMessages_1, e_1, wrappedError, errorAction;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setText("");
                    sentMessage = {
                        text: _text,
                        timestamp: Date.now(),
                        owner: Owner.User,
                    };
                    props.addMessage(sentMessage);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    setIsTyping(true);
                    return [4 /*yield*/, props.chatbotService.reply({
                            text: _text,
                            chatId: props.chatId,
                            meta: {
                                email: (_a = props.preChatData) === null || _a === void 0 ? void 0 : _a.email,
                                firstName: (_b = props.preChatData) === null || _b === void 0 ? void 0 : _b.firstName,
                                lastName: (_c = props.preChatData) === null || _c === void 0 ? void 0 : _c.lastName,
                                assistantId: props.assistantId,
                                departments: props.departments,
                            },
                        })];
                case 2:
                    replyMessages_1 = _d.sent();
                    if (!replyMessages_1.length || replyMessages_1.length === 0) {
                        throw new Error("No reply messages");
                    }
                    replyMessages_1.reverse().forEach(function (message, idx) {
                        if (message.action) {
                            props.onAction(message.action);
                        }
                        props.addMessage(message);
                        if (idx === replyMessages_1.length - 1) {
                            setIsTyping(false);
                        }
                        else {
                            setTimeout(function () {
                                console.debug("More messages to come");
                            }, 2000);
                        }
                    });
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _d.sent();
                    setIsTyping(false);
                    wrappedError = new ConsumerChatbotError(e_1);
                    errorAction = {
                        type: "error",
                        message: _text,
                    };
                    props.addMessage({
                        owner: Owner.Bot,
                        text: "I'm sorry we seem to be having some issues. Would you like to talk to one of our team?",
                        action: errorAction,
                        timestamp: Date.now(),
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [
        text,
        props.chatbotService,
        props.chatId,
        props.addMessage,
        props.onAction,
    ]);
    var handleClose = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (typeof window !== "undefined") {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: "gtm-chatbot-end-chat-attempt",
                    session_id: new Date().getTime(),
                    requestStatus: "gtm-chatbot-end-chat-attempt",
                });
                if (window.confirm("Are you sure you want to end the chat?")) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: "gtm-chatbot-end-chat-confirmed",
                        session_id: new Date().getTime(),
                        requestStatus: "gtm-chatbot-end-chat-confirmed",
                    });
                    props.resetThread();
                    props.resetMessages();
                    props.onClose();
                }
            }
            return [2 /*return*/];
        });
    }); }, [props.resetThread, props.resetMessages, props.onClose]);
    var onHumanHandoff = useCallback(function (index, action) {
        var _a, _b, _c;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "gtm-chatbot-humanhandoff",
            session_id: new Date().getTime(),
            requestStatus: "gtm-chatbot-humanhandoff",
        });
        props.addMessage({
            owner: Owner.Bot,
            text: "You are now being transferred to the next available agent, there may be a short queue. Please note our agents are only available Weekdays 8am - 8pm & Weekends 9am - 5pm",
            timestamp: Date.now(),
        });
        props.chatbotService.action({
            type: "human-handoff",
            chatId: props.chatId,
            meta: {
                firstName: (_a = props.preChatData) === null || _a === void 0 ? void 0 : _a.firstName,
                lastName: (_b = props.preChatData) === null || _b === void 0 ? void 0 : _b.lastName,
                email: (_c = props.preChatData) === null || _c === void 0 ? void 0 : _c.email,
                assistantId: props.assistantId,
                departments: props.departments,
            },
        });
        props.onHumanHandoff(index, action);
    }, [
        props.onHumanHandoff,
        props.chatbotService,
        props.chatId,
        props.preChatData,
    ]);
    var onTryAgain = useCallback(function (index, action) {
        onSend(action.message);
    }, [onSend, setText]);
    var onRemember = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, chatId_1, messages_1, e_2, errorAction, eventData;
        var _b, _c, _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, , 3]);
                    setIsTyping(true);
                    return [4 /*yield*/, props.chatbotService.init({
                            meta: {
                                firstName: (_b = props.preChatData) === null || _b === void 0 ? void 0 : _b.firstName,
                                lastName: (_c = props.preChatData) === null || _c === void 0 ? void 0 : _c.lastName,
                                email: (_d = props.preChatData) === null || _d === void 0 ? void 0 : _d.email,
                                assistantId: props.assistantId,
                                departments: props.departments,
                            },
                            chatId: props.chatId,
                        })];
                case 1:
                    _a = _e.sent(), chatId_1 = _a.chatId, messages_1 = _a.messages;
                    messages_1.forEach(function (message, idx) {
                        if (message.action) {
                            props.onAction(message.action);
                        }
                        props.addMessage(message);
                        if (idx === messages_1.length - 1) {
                            if (chatId_1 !== props.chatId) {
                                props.setChatId(chatId_1);
                            }
                            setIsTyping(false);
                        }
                    });
                    return [3 /*break*/, 3];
                case 2:
                    e_2 = _e.sent();
                    setIsTyping(false);
                    errorAction = {
                        type: "error",
                        message: "",
                    };
                    props.addMessage({
                        owner: Owner.Bot,
                        text: "I'm sorry we seem to be having some issues. Would you like to talk to one of our team?",
                        action: errorAction,
                        timestamp: Date.now(),
                    });
                    window.dataLayer = window.dataLayer || [];
                    eventData = {
                        event: "gtm-chatbot-errored",
                        session_id: new Date().getTime(),
                        requestStatus: "gtm-chatbot-errored",
                    };
                    window.dataLayer.push(eventData);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [
        props.chatbotService,
        props.preChatData,
        props.assistantId,
        props.departments,
        props.chatId,
        props.addMessage,
        props.onAction,
        props.setChatId,
    ]);
    var onSubmitIPRequest = useCallback(function (service) { return __awaiter(void 0, void 0, void 0, function () {
        var messages_2, e_3, errorAction;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    setIsTyping(true);
                    return [4 /*yield*/, props.chatbotService.action({
                            data: service,
                            meta: {
                                firstName: (_a = props.preChatData) === null || _a === void 0 ? void 0 : _a.firstName,
                                lastName: (_b = props.preChatData) === null || _b === void 0 ? void 0 : _b.lastName,
                                email: (_c = props.preChatData) === null || _c === void 0 ? void 0 : _c.email,
                                assistantId: props.assistantId,
                                departments: props.departments,
                            },
                            chatId: props.chatId,
                            type: "confirm_request_ipv6",
                        })];
                case 1:
                    messages_2 = _d.sent();
                    messages_2.forEach(function (message, idx) {
                        if (message.action) {
                            props.onAction(message.action);
                        }
                        props.addMessage(message);
                        if (idx === messages_2.length - 1) {
                            setIsTyping(false);
                        }
                        else {
                            setTimeout(function () {
                                console.debug("More messages to come");
                            }, 500);
                        }
                    });
                    return [3 /*break*/, 3];
                case 2:
                    e_3 = _d.sent();
                    setIsTyping(false);
                    errorAction = {
                        type: "error",
                        message: "",
                    };
                    props.addMessage({
                        owner: Owner.Bot,
                        text: "I'm sorry we seem to be having some issues. Would you like to talk to one of our team?",
                        action: errorAction,
                        timestamp: Date.now(),
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, []);
    return (_jsx(ChatbotBox, { uiLabels: props.uiLabels, width: props.width, height: props.height, emoji: _jsx(RobotIcon, { height: "1.5em", width: "1.5em", color: "var(--text-color)" }), messages: props.messages, text: text, loading: isTyping, onSend: function () { return onSend(text); }, onClose: handleClose, onMinimize: props.onMinimize, onChange: setText, error: error, onGoodFeedback: onGoodFeedback, onBadFeedback: onBadFeedback, disabled: isTyping, onHumanHandoff: onHumanHandoff, onTryAgain: onTryAgain, onRemember: onRemember, onSubmitIpRequest: onSubmitIPRequest }));
};
export default ChatWindow;
